import HTTP from './index';

export const fetchSectorlist = () => HTTP.get("/survey/1/sector/list");
export const fetchSectorAverage = (sectorId, targetCountries, isExporter,
    companyMaturityTypes) => HTTP.post(
    `/survey/1/sector/average`,
    {sectorId, targetCountries, isExporter, companyMaturityTypes});
export const fetchSector = (sectorId, targetCountries, isExporter,
    companyMaturityTypes, page = 0, size = 100) => HTTP.post(
    `/survey/1/sector`,
    {sectorId, targetCountries, isExporter, companyMaturityTypes},
    {params: {page, size}});
export const fetchQuestionAll = () => HTTP.get(
    '/survey/1/questionnaire/1/question/public/questions-all');
